import { useEffect, useState } from "react";

export const useRecords = (entity) => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    setLoading(true);
    entity.list("-created_date", 200)
      .then((items) => { if (active) setRecords(items); })
      .catch((failure) => { if (active) setError(failure.message); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [entity]);
  return { records, setRecords, loading, error, setError };
};